import { gql, useMutation } from '@apollo/client';

import { OdProtosWebData_VirtualAssessmentRecordingInput } from '../../../__generated__/athenaGlobalTypes';
import {
  UpdateSSVARecordings,
  UpdateSSVARecordingsVariables,
} from '../../../graphql/athena/mutations/__generated__/UpdateSSVARecordings';
import { VirtualAssessmentQuery } from '../queries/useVirtualAssessmentData';

const UPDATE_SSVA_RECORDINGS = gql`
  mutation UpdateSSVARecordings(
    $sellerInputUUID: String!
    $ssvaRecordings: [OdProtosWebData_VirtualAssessmentRecordingInput!]
  ) {
    sellDirect {
      updateSSVARecordings(
        input: {
          recordings: $ssvaRecordings
          lead: { source: { type: RECEPTION, id: $sellerInputUUID } }
        }
      ) {
        virtualAssessment {
          id
          ssvaRecordingsSubmitted
          ssvaQuestionnaireSubmitted
          ssvaInteriorRecordingsSubmitted
          ssvaFrontyardRecordingsSubmitted
          ssvaBackyardRecordingsSubmitted
          ssvaRecordings {
            id
            recordedFeature
            s3Directory
            fileName
          }
        }
      }
    }
  }
`;

/**
 * Hook to update the virtual assessment recordings
 */
export const useUpdateVirtualAssessmentRecordings = (sellerInputUUID: string) => {
  const [updateWebMutation, mutationResp] = useMutation<
    UpdateSSVARecordings,
    UpdateSSVARecordingsVariables
  >(UPDATE_SSVA_RECORDINGS, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [VirtualAssessmentQuery],
  });

  const updateSSVARecordings = (
    ssvaRecordings: Array<OdProtosWebData_VirtualAssessmentRecordingInput>,
  ) =>
    updateWebMutation({
      variables: { sellerInputUUID, ssvaRecordings },
    });

  return {
    updateSSVARecordings,
    ssvaRecordings:
      mutationResp.data?.sellDirect.updateSSVARecordings?.virtualAssessment?.ssvaRecordings ?? [],
    loading: mutationResp.loading,
    error: mutationResp.error,
  };
};
